var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9151_66)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 87.5,
    r: 87.5,
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9151_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.6029 106.587L82.9154 118.41C75.7855 125.43 64.3803 125.274 57.4409 118.061C50.6355 110.988 50.634 99.7187 57.4374 92.6431L69.1248 80.809C70.5238 79.3927 70.523 77.0973 69.123 75.682C67.7229 74.2667 65.454 74.2676 64.0549 75.6839L52.3711 87.5181C42.5395 97.469 42.5435 113.599 52.38 123.545C62.2164 133.491 78.1606 133.486 87.9924 123.536L99.6798 111.712C101.054 110.272 101.015 107.978 99.5918 106.587C98.2034 105.231 96.002 105.231 94.6136 106.587H94.6029V106.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.621 51.4703C118.911 46.6735 112.5 43.9833 105.817 44.0001C99.1379 43.9821 92.7288 46.6667 88.0172 51.4559L76.3118 63.2828C74.9118 64.6981 74.9109 66.9934 76.3099 68.4097C77.709 69.826 79.978 69.8269 81.378 68.4116L93.0761 56.5883C96.4454 53.1593 101.031 51.2369 105.81 51.2493C115.759 51.2527 123.822 59.4146 123.819 69.4796C123.817 74.3103 121.92 78.9428 118.543 82.359L106.856 94.1823C105.456 95.5986 105.456 97.8949 106.856 99.3112C108.256 100.727 110.526 100.727 111.926 99.3112L123.613 87.495C133.431 77.5415 133.434 61.4276 123.621 51.4703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.208 74.0603L74.7105 95.8078C73.2871 97.1984 73.2478 99.4931 74.6225 100.933C75.9972 102.373 78.2655 102.413 79.6887 101.022C79.7186 100.993 79.7478 100.963 79.7767 100.933L101.274 79.1854C102.649 77.7455 102.609 75.451 101.186 74.0603C99.7977 72.7038 97.5966 72.7038 96.208 74.0603Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9151_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9151_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 87,
    fill: "white",
    transform: "translate(45 44)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.92925a4360e3598514acdcd5faaffe1a.svg";
export { ForwardRef as ReactComponent };